import React, { useState } from "react";
import {
  CardsWrapper,
  CTAButton,
  SettingsButton,
  Styled,
  TabbedSection,
} from "./styled";
import "./style.css";
import { CiSettings } from "react-icons/ci";
import { FiUsers } from "react-icons/fi";
import { CiVideoOn } from "react-icons/ci";
import { SlGraph } from "react-icons/sl";

import { Row, Col, Modal, Button, Form, Input, Select, message, Card } from "antd";
import Overview from "./tabs/overview/Groups";
import Members from "./tabs/members/Members";
import Videos from "./tabs/videos/Videos";
import Analytics from "./tabs/analytics/Analytics";
import {
  CustomButton,
  CustomTitle,
  CustomSubTitle,
} from "../physician_page/styled";
import { PlusOutlined } from "@ant-design/icons";
import AddGroupModal from "./AddGroupModal";

const { Option } = Select;
const { TextArea } = Input;

const Groups = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // tab section
  const [activeTab, setActiveTab] = useState("Overview");

  return (
    <>
      <Styled.Wrapper>
        <Row className="custom-header" style={{ marginBottom: "25px" }}>
          <Col className="header-item">
            <CustomTitle>Groups</CustomTitle>
            <CustomSubTitle>
              Manage specialty groups, their members, and associated content.
            </CustomSubTitle>
          </Col>
          {
            activeTab === "Overview" && (
              <Col className="custom-btn">
              <CustomButton onClick={()=> setIsModalOpen(true)}>
                <PlusOutlined className="font-18 mt-5" />
                Add Group
              </CustomButton>
              {/* <CustomSecondaryButton>
                <SettingOutlined className="font-18" />
              </CustomSecondaryButton> */}
            </Col>
            )
          }
         
        </Row>

        <Row gutter={[16, 16]}>
          <Col lg={6} md={12} sm={24} xs={24}>
            <Card className="custom-cards">
              <Col
                className="d-flex mb-5"
                style={{ justifyContent: "space-between" }}
              >
                <div className="font-16 font-semibold text-primary">
                  Total Groups
                </div>
                <div>
                  <FiUsers className="font-19 text-secondry" />
                </div>
              </Col>
              <Col className="font-27 font-bold mb-5 text-primary">5</Col>
              <Col className="font-15 text-secondry">
                +2 added this month
              </Col>
            </Card>
          </Col>
          <Col lg={6} md={12} sm={24} xs={24}>
            <Card className="custom-cards">
              <Col
                className="d-flex mb-5"
                style={{ justifyContent: "space-between" }}
              >
                <div className="font-16 font-semibold text-primary">
                  Total Members
                </div>
                <div>
                  <FiUsers className="font-19 text-secondry" />
                </div>
              </Col>
              <Col className="font-27 font-bold mb-5 text-primary">48</Col>
              <Col className="font-15 text-secondry">
                +8 joined this month
              </Col>
            </Card>
          </Col>
          <Col lg={6} md={12} sm={24} xs={24}>
            <Card className="custom-cards">
              <Col
                className="d-flex mb-5"
                style={{ justifyContent: "space-between" }}
              >
                <div className="font-16 font-semibold text-primary">
                  Total Videos
                </div>
                <div>
                  <CiVideoOn className="font-19 text-secondry" />
                </div>
              </Col>
              <Col className="font-27 font-bold mb-5 text-primary">326</Col>
              <Col className="font-15 text-secondry">+24 added this month</Col>
            </Card>
          </Col>
          <Col lg={6} md={12} sm={24} xs={24}>
            <Card className="custom-cards">
              <Col
                className="d-flex mb-5"
                style={{ justifyContent: "space-between" }}
              >
                <div className="font-16 font-semibold text-primary">
                  Total Views
                </div>
                <div>
                  <SlGraph className="font-19 text-secondry" />
                </div>
              </Col>
              <Col className="font-27 font-bold mb-5 text-primary">17,508</Col>
              <Col className="font-15 text-secondry">
                +15% from last month
              </Col>
            </Card>
          </Col>
        </Row>

        <TabbedSection>
          <ul className="tablist">
            <li>
              <div
                className={`button ${activeTab === "Overview" ? "active" : ""}`}
                onClick={() => setActiveTab("Overview")}
              >
                Overview
              </div>
            </li>
            <li>
              <div
                className={`button ${activeTab === "Members" ? "active" : ""}`}
                onClick={() => setActiveTab("Members")}
              >
                Members
              </div>
            </li>
            <li>
              <div
                className={`button ${activeTab === "Videos" ? "active" : ""}`}
                onClick={() => setActiveTab("Videos")}
              >
                Videos
              </div>
            </li>
            {/* <li>
              <div
                className={`button ${
                  activeTab === "Analytics" ? "active" : ""
                }`}
                onClick={() => setActiveTab("Analytics")}
              >
                Analytics
              </div>
            </li> */}
          </ul>

          {activeTab === "Overview" && 
          <Overview isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
          }
          {activeTab === "Members" && <Members />}
          {activeTab === "Videos" && <Videos />}
          {/* {activeTab === "Analytics" && <Analytics />} */}
        </TabbedSection>
      </Styled.Wrapper>
    </>
  );
};

export default Groups;
